import ObjectDisplayController from "ips/ac/controller/scfld/ObjectDisplay.controller";
import InvitationTokenMailService from "ips/ac/data/invitation/service/InvitationTokenMailService";

/**
 * @namespace ips.ac.data.client.invitation-token
 */
export default class ClientInvitationTokenDetails extends ObjectDisplayController {

  public async onSendAgain() {
    const guid = this.getView().getBindingContext().getProperty("Guid");

    await InvitationTokenMailService.resendClientOnboardingMail(this.getView(), guid);
  }
}
